// removed by extract-text-webpack-plugin
module.exports = {"component":"fWxPgaBjwHiWPOAPdKbrr","topTitle":"_3ALfWDf02hPY9BbvJ6-dLe","orderStatus":"PUc81zUyy9khljvnBe731","xiola":"_1YrLwcnYRFTbk8gllY-Ebw","xiolb":"_3S4t66uaT4rzNbWHoju0Gt","xiolc":"_22ENgtvtTkD3nqpIVVakaQ","newPage":"_1OKoqNd96J664vcSxocung","pageTopTitle":"_24b1feZffXh83jTi-QSmjz","linka":"_2FrqFpQHyX1fzS4S9ZZ7pt","serviceEvaluate":"_1qvZNP3xmvbt7FScV_IVGa","serviceTip":"_3SXA7YgqJCbW1IX_V8lY3z","productEvaluate":"Vmx7agv6UQdNSmABRZPzW","left":"djV3BUa2xR5vR0kS7g85j","right":"_-Bd32lfrs2feTDSYa2fGw","linkBtn":"_2TVa5ErYaKb30zRrhd_L2v","btn":"_3dgjKSfkHp1DXAgqGhpkzm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OrderEvaluateComponent/OrderEvaluateComponent.scss
 ** module id = 1003
 ** module chunks = 0
 **/